import { AddBox } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import React from 'react';
import {
    SimpleFormIterator,
    ReferenceInput,    
    ArrayField,
    ReferenceField,
    TextField,
    NumberField,
    Datagrid,
    useGetOne,
    maxLength,
    regex,
    FormDataConsumer} from 'react-admin';
import { ArrayInput, AutocompleteInput, DateInput, NumberInput } from './wrappers/Inputs';
import dayjs from 'dayjs';


export const regString = regex(/^[A-Za-z]+$/, 'Must be a text value');
export const regNumber = regex(/^[A-Za-z]+$/, 'Must be a text value');

export const JACSCodesInput = (props) =>
    <ArrayInput {...props} source="jacsCodes" validate={validateWeightings}>
        <SimpleFormIterator disableReordering fullWidth>
            <ReferenceInput reference="JacsCode" source="jacsCodeId"  label="JACS Code">
                <AutocompleteInput optionText="Title" />
            </ReferenceInput>
            <NumberInput source="weighting" label="Weighting"/>
        </SimpleFormIterator>
    </ArrayInput>

export const JACSCodesShow = (props) => 
    <ArrayField {...props} source="jacsCodes" >
        <Datagrid>
            <ReferenceField source="jacsCodeId" label="myroot.jacsCode" reference="JacsCode" link="show" >
                <TextField source="Title" />
            </ReferenceField>                
            <ReferenceField source="jacsCodeId" label="myroot.ascCode" reference="JacsCode" link="show">
                <ReferenceField source="asccode_id" reference="AscCode">
                    <TextField source = "description" /> 
                </ReferenceField>
            </ReferenceField>           
            <NumberField source="weighting" />
        </Datagrid>
    </ArrayField>

export const HECOSCodesInput = (props) => 
    <ArrayInput {...props} label={false} source="hecosCodes" validate={validateWeightings}>
        <SimpleFormIterator disableReordering fullWidth>
            <ReferenceInput reference="HecosCode" source="hecosCodeId" label="myroot.HECOScodes" fullWidth>
                <AutocompleteInput optionText={optText} sx={{ width: 1/3}} fullWidth/>
            </ReferenceInput>
            <NumberInput source="weighting" label="Weighting" fullWidth/>
        </SimpleFormIterator>
    </ArrayInput>

export const HECOSCodesShow = (props) => 
    <ArrayField {...props} source="hecosCodes">
        <Datagrid bulkActionButtons={false}>
            <ReferenceField source="hecosCodeId" label="myroot.HECOScodes" reference="HecosCode" link="show" >
                <TextField source="Title" />
            </ReferenceField>
            <ReferenceField source="hecosCodeId" label="myroot.ascCode" reference="HecosCode" link="show" >
                <ReferenceField source="ascCode" reference="AscCode" >
                    <TextField source="description" />
                </ReferenceField>
            </ReferenceField>
            <NumberField source="weighting"/>
        </Datagrid>
    </ArrayField>   
    
// const validateVersioningType = (value, allValues, resource) => {
//     if ((resource === 'Course' || resource === 'Module' ) && allValues.id && !value) {
//         return 'Version type is required';
//     }
//     return undefined;
// };

export const optText = choice => `${choice.code} - ${choice.Title}`;

// export const VersioningTypeInput = ({ source, resource }) => {
//     const options = [
//         { id: 'validated', name: 'Validated' },
//         { id: 'modified', name: 'Modified' },
//         { id: 'corrected', name: 'Corrected' }
//     ]
//     if(resource == "Course"){
//         options.push({ id: 'perpetuallyValidated', name: 'Perpetually validated' })
//     }
//     return (
//         <Box display="flex" sx={{marginTop: '20px', minWidth: '200px'}}>
//             <Box flex={1}>
//                 <AutocompleteInput
//                     fullWidth
//                     source={source}
//                     choices={options}
//                     validate={(value, allValues) =>
//                         validateVersioningType(value, allValues, resource)
//                     }
//                 />
//             </Box>
//         </Box>
//     );
// };

export const validDatesValidation = (_value, allValues) => {
    if (allValues.validationTo < allValues.validationFrom) {
        return 'Validation to cannot be before validation from';
    }

    return undefined;
};

export const validDateValidation = (_value) => {
    // if (validator.isDate(_value)) {
    //     setErrorMessage('Valid Date :)')
    //   } else {
    //     setErrorMessage('Enter Valid Date!')
    //   }

    // return undefined;
};

export const TitleLengthCheck = maxLength(80, "Please make sure title length is less that 80 characters!");

export const QualificationRender = ({qualificationId}) => {
    const  { data: qualification } = useGetOne('QualificationType', { id: qualificationId});
    return (
        <span>
            {qualification?.Title} 
        </span>
    );
}
export const QualificationTitleRender = ({record, qualificationId}) => {
    const  { data: qualification } = useGetOne('QualificationType', { id: qualificationId});
    return (
        <Typography>
            {qualification?.Title} in {record?.Title}
            <small  style={{color: "#bfbfbf", display: "block"}}>
            v{record?.version} - Valid from {new Date(record?.validationFrom).toLocaleDateString('en-gb', { day: "numeric", year:"numeric", month:"short"})} to {new Date(record?.validationTo).toLocaleDateString('en-gb', { day: "numeric", year:"numeric", month:"short"})}
            </small>
        </Typography>
        
    );
}

const validateWeightings = (codes) => {
    if (codes !== null && codes !== undefined && codes.length !== 0) {

        var filteredCodes = codes.filter(function (el) {
            return (el === undefined || ((el.hecosCodeId === null || el.hecosCodeId === '' || el.hecosCodeId === undefined) && (el.jacsCodeId === null || el.jacsCodeId === '' || el.jacsCodeId === undefined)))
        });

        if (filteredCodes.length !== 0 || !filteredCodes) {
                return 'Code should be selected';
        }

        if (codes.length > 5) {
            return 'You can add max 5 codes';
        }
        else if (codes) {
            var totalWeightings = 0.;
            codes?.forEach(function (code) {
                totalWeightings += parseFloat(code.weighting);
            });

            if (totalWeightings !== 100) {
                return 'Code weightings must add up to exactly 100';
            }
        }

    }
    return undefined;
};  

const validStartAndEndDate = (value, _allValues, scopedFormData) => {
    if (dayjs(scopedFormData.endDate) < dayjs(scopedFormData.startDate)) {
        return 'End date to cannot be before start date';
    }

    return undefined;
};


export const PrsbAccreditations = (props) => {
    return (
        <ArrayInput source="prsbAccreditations" fullWidth label={false}>
            <SimpleFormIterator disableReordering fullWidth>
                <FormDataConsumer>
                    {({ getSource, scopedFormData }) => (
                        <Box
                            display="flex"
                            width={1}
                            justifyContent="space-between"
                        >
                            <Box flex={4} ml="0.5em">
                                <ReferenceInput
                                    reference="ProfessionalBody"
                                    source={getSource('prsbId')}
                                    fullWidth
                                    
                                >
                                    <AutocompleteInput
                                        optionText="Title"
                                        fullWidth
                                        label='PSRB'
                                    />
                                </ReferenceInput>
                            </Box>
                            <Box flex={2} ml="0.5em">
                                <AutocompleteInput
                                    source={getSource('prsbType')}
                                    label='PSRB Type'
                                    choices={[
                                        {
                                            id: 'Accredited',
                                            name: 'Accredited',
                                        },
                                        {
                                            id: 'Endorsed',
                                            name: 'Endorsed'
                                        },
                                        {
                                            id: 'Partnership',
                                            name: 'Partnership',
                                        },
                                        {
                                            id: 'Recognised',
                                            name: 'Recognised',
                                        },
                                        {
                                            id: 'SelfAcredited',
                                            name: 'Self-Acredited',
                                        }
                                    ]}
                                fullWidth
                                />
                            </Box>
                            <Box
                                flex={2}
                                display="flex"
                                justifyContent="space-evenly"
                                ml="0.5em"
                            >
                                <DateInput source={getSource('startDate')} />
                                <DateInput
                                    source={getSource('endDate')}
                                    ml="0.5em"
                                    validate={(value, allValues) =>
                                        validStartAndEndDate(
                                            value,
                                            allValues,
                                            scopedFormData
                                        )
                                    }
                                />
                            </Box>
                        </Box>
                    )}
                </FormDataConsumer>
            </SimpleFormIterator>
        </ArrayInput>
    );
};